import React, { Component } from 'react';
interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}
export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };
  public static getDerivedStateFromError(_: Error): State {
    return {
      hasError: true
    };
  }
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }
  public render() {
    if (this.state.hasError) {
      return <div className="min-h-screen bg-stone-50 flex items-center justify-center p-4" data-id="element-81">
          <div className="max-w-md mx-auto text-center" data-id="element-82">
            <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-83">
              Något gick fel
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-84">
              Det verkar som om en browser-extension orsakar problem. Prova att
              ladda om sidan eller stänga av tillägg tillfälligt.
            </p>
            <button onClick={() => window.location.reload()} className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors" data-id="element-85">
              Ladda om sidan
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}